import React, { createContext, useState, useEffect, useCallback } from 'react';
import { SupportedLanguage, TranslationDictionary, TranslationContextValue } from './types';
import { detectLanguage, fetchTranslations } from './translationService';

export const TranslationContext = createContext<TranslationContextValue>({
  t: (key: string) => key,
  language: 'es',
});

export const TranslationProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [language] = useState<SupportedLanguage>(detectLanguage);
  const [translations, setTranslations] = useState<TranslationDictionary>({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchTranslations(language)
      .then(setTranslations)
      .finally(() => setLoading(false));
  }, [language]);

  const t = useCallback((key: string, params?: Record<string, string>): string => {
    let text = translations[key] || key;
    if (params) {
      Object.entries(params).forEach(([param, value]) => {
        text = text.replace(new RegExp(`\\{\\{${param}\\}\\}`, 'g'), value);
      });
    }
    return text;
  }, [translations]);

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        background: '#0f1729',
      }}>
        <div style={{
          width: 36,
          height: 36,
          border: '3px solid rgba(255,255,255,0.15)',
          borderTopColor: '#4f9cf7',
          borderRadius: '50%',
          animation: 'spin 0.8s linear infinite',
        }} />
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      </div>
    );
  }

  return (
    <TranslationContext.Provider value={{ t, language }}>
      {children}
    </TranslationContext.Provider>
  );
};
